import React from "react"
import PropTypes from "prop-types"
import {
  CloseIcon,
  NotPermittedIcon,
  CheckedIcon,
  InfoIcon,
  WarningIcon
} from "../Icons"
import "./Alert.css"

function Alert({ type, message, close, sidebarHidden }) {
  return (
    <div
      className={`Alert ${sidebarHidden ? "sidebar" : null} ${(type &&
        type === "success" &&
        "success") ||
        (type && type === "error" && "error") ||
        (type && type === "info" && "info") ||
        (type && type === "warning" && "warning") ||
        "default"}`}
    >
      <span className="Alert-icon">
        {(type && type === "success" && <CheckedIcon />) ||
          (type && type === "error" && <NotPermittedIcon />) ||
          (type && type === "info" && <InfoIcon />) ||
          (type && type === "warning" && <WarningIcon />) || <CheckedIcon />}
      </span>
      <span className="Alert-message">{message}</span>
      <button className="Alert-close" onClick={close}>
        <CloseIcon />
      </button>
    </div>
  )
}

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired
}

export default Alert
